import React, {useEffect, useState} from 'react'
import { Table } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import InputMask from 'react-input-mask';
import axios from 'axios'
import { dataTableRender, validaCNPJ, cor, corEnviado, rotulo, rotuloEnviado, validaCPF } from '../components/functions'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useEmailVerContext } from '../context/emailVerContext'

import ModalLogin from '../modals/loginAdesaoInstitucional'
import ModalPerfilAnual from '../modals/perfilAnual'
import ModalPerfilAnualCorp from '../modals/perfilAnualCorp'

import ModalProcessaPlanilhaClima from '../modals/processaPlanilhaClima'
import ModalDesafioClima from '../modals/desafioClima'
import ModalOcorrencia from '../modals/ocorrencia'
import ModalAviso from '../modals/aviso'
import ModalResiduo from '../modals/residuo'
import ModalEnergia from '../modals/energia'
import ModalCompras from '../modals/compras'
import ModalSenhaAdesaoInstitucional from '../modals/senhaAdesaoInstitucional'
import ModalEmailSenha from '../modals/emailSenha'
import ModalCartaAdesao from '../modals/cartaAdesao'

import ModalValidacao from '../modals/validacao'
import ModalEmailCorrecao from '../modals/emailCorrecao'
import ModalEmailVer from '../modals/emailVer'

import ModalDetalheAlteracao from '../modals/detalheAlteracao'
import ModalDesafios from '../modals/modalDesafios'

const InstitucionalInfo = (props) => {


    const history = useHistory();

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    //var linkAPI = 'http://172.16.1.253:3600/'
    var linkAPI = 'https://cdn.hospitaissaudaveis.org/'

    var slug = props.match.params.adesao_institucional_id

    var [formulario_id, setFormulario_id] = useState()
    var [origem, setOrigem] = useState()

    var [adesao_institucional_id, setAdesaoInstitucional_id] = useState(slug)

    var [ano, setAno] = useState()
    var [razao_social, setRazaoSocial] = useState()
    var [nome_fantasia, setNomeFantasia] = useState()
    var [adesao_institucional_id_ref, setAdesao_institucional_id_ref] = useState()
    var [email, setEmail] = useState()
    var [cnes, setCnes] = useState()
    var [numero, setNumero] = useState()
    var [endereco, setEndereco] = useState()
    var [cep, setCep] = useState()
    var [bairro, setBairro] = useState()
    var [municipio, setMunicipio] = useState()
    var [listaUF, setListaUF] = useState()
    var [uf_codigo, setUfCodigo] = useState()
    var [cnpj, setCNPJ] = useState()
    var [nome_pessoa_preenche, setNomePessoaPreenche] = useState()
    var [cargo_pessoa_preenche, setCargoPessoaPreenche] = useState()
    var [telefone_pessoa_preenche, setTelefonePessoaPreenche] = useState()

    var [listaOrganizacao, setListaOrganizacao] = useState()
    var [listaAmbito, setListaAmbito] = useState()
    var [listaNatureza, setListaNatureza] = useState()
    var [categoria_adesao, setCategoriaAdesao] = useState()
    var [organizacao_ambito_id, setOrganizacaoAmbitoId] = useState()
    var [organizacao_espec_id, setOrganizacaoEspecId] = useState()
    var [organizacao_id, setOrganizacaoId] = useState()

    var [resultadoPerfilAnual, setResultadoPerfilAnual] = useState()
    var [resultadoClima, setResultadoClima] = useState()
    var [resultadoResiduos, setResultadoResiduos] = useState()
    var [resultadoEnergia, setResultadoEnergia] = useState()
    var [resultadoLogins, setResultadoLogins] = useState()
    var [resultadoAvisos, setResultadoAvisos] = useState()
    var [nao_tem_cnes, setNao_tem_cnes] = useState()

    var [possuiCnes, setPossuiCnes] = useState('')
    var [varios_cnes, setVariosCnes] = useState('')
    var [email, setEmail] = useState('')
    var [confirmaEmail, setConfirmaEmail] = useState('')
    var [porte_organizacao, setPorteOrganizacao] = useState('')

    var [resultadoCompras, setResultadoCompras] = useState()
    var [resultadoOcorrencias, setResultadoOcorrencias] = useState()

    var [login_id, setLoginId] = useState()

    var [totalLogin, setTotalLogin] = useState(0)
    var [totalPerfilAnual, setTotalPerfilAnual] = useState(0)
    var [totalClima, setTotalClima] = useState(0)
    var [totalResiduos, setTotalResiduos] = useState(0)
    var [totalEnergia, setTotalEnergia] = useState(0)
    var [totalCompras, setTotalCompras] = useState(0)
    var [totalOcorrencias, setTotalOcorrencias] = useState(0)
    var [totalAvisos, setTotalAvisos] = useState(0)
    var [totalOrgAfiliadas, setTotalOrgAfiliadas] = useState(0)

    var [hospClima_id, setHospClima_id] = useState()
    var [ocorrencia_id, setOcorrencia_id] = useState()

    var [aviso_id, setAviso_id] = useState()
    
    var [ano, setAno] = useState()
    var [residuo_id, setResiduo_id] = useState()
    var [publica_no_site, setPublicaNoSite] = useState(false)


    var [uploadArquivoRtZDataHora, setUploadArquivoRtZDataHora] = useState()
    var [arquivoRtZ, setArquivoRtZ] = useState()
    var [statusArquivoRtZ, setStatusArquivoRtZ] = useState()

    var [metaRtZ2030, setMetaRtZ2030] = useState()
    var [metaRtZ2050, setMetaRtZ2050] = useState()
    var [cartaAdesao, setCartaAdesao] = useState()

    var [exportarAPI, setExportarAPI] = useState()
    
    var [listaServicosSaude, setListaServicosSaude] = useState()    
    var [unidadesVinculadas, setUnidadesVinculadas] = useState()


    const [cnpjAnterior, setCnpjAnterior] = useState('')
    const [nomeFantasiaAnterior, setNomeFantasiaAnterior] = useState('')
    const [razaoSocialAnterior, setRazaoSocialAnterior] = useState('')
    const [organizacaoGestoraAnterior, setOrganizacaoGestoraAnterior] = useState('')
    const [organizacaoGestora, setOrganizacaoGestora] = useState('')


    const [cepAnterior, setCepAnterior] = useState('')
    const [enderecoAnterior, setEnderecoAnterior] = useState('')
    const [numeroAnterior, setNumeroAnterior] = useState('')
    const [bairroAnterior, setBairroAnterior] = useState('')
    const [municipioAnterior, setMunicipioAnterior] = useState('')
    const [ufAnterior, setUfAnterior] = useState('')
    const [emailAnterior, setEmailAnterior] = useState('')
    const [telefoneAnterior, setTelefoneAnterior] = useState('')
    const [nomePessoaPreencheuAnterior, setNomePessoaPreencheuAnterior] = useState('')
    const [cargoPessoaPreencheuAnterior, setCargoPessoaPreencheuAnterior] = useState('')
    
    const [categoriaAdesaoAnterior, setCategoriaAdesaoAnterior] = useState('')
    //const [categoriaAdesaoAtual, setCategoriaAdesaoAtual] = useState('')
    
    const [ambitoOrganizacaoAnterior, setAmbitoOrganizacaoAnterior] = useState('')
    const [ambitoOrganizacao, setAmbitoOrganizacao] = useState('')
    

    const [especOrganizacao, setEspecOrganizacao] = useState('')
    const [especOrganizacaoAnterior, setEspecOrganizacaoAnterior] = useState('')
    
    //const [organizacaoAnterior, setOrganizacaoAnterior] = useState('')
    
    const [tipoOrganizacaoAnterior, setTipoOrganizacaoAnterior] = useState('')
    const [tipoOrganizacao, setTipoOrganizacao] = useState('')

    const [porteOrganizacaoAnterior, setPorteOrganizacaoAnterior] = useState('')
    
    const [organizacao, setOrganizacao] = useState('')
    const [organizacaoAnterior, setOrganizacaoAnterior] = useState('')

    const [cnesAnterior, setCnesAnterior] = useState('')

    const [totalAlteracoes, setTotalAlteracoes] = useState(0)
    const [resultadoAlteracoes, setResultadoAlteracoes] = useState([])
    const [alteraAdesaoInstitucional_id, setAlteraAdesaoInstitucional_id] = useState()


    const [telefoneCelular, setTelefoneCelular] = useState('')    
    const [complexidade, setComplexidade] = useState('')
    const [contratoGestao, setContratoGestao] = useState('')
    const [nomeOutraOrganizacaoGestora, setNomeOutraOrganizacaoGestora] = useState('')
    const [emailRepresentante, setEmailRepresentante] = useState('')
    const [site, setSite] = useState('')
    const [vinculacaoSUS, setVinculacaoSUS] = useState('')
    const [hospitalEspecializado, setHospitalEspecializado] = useState()
    const [especializacao, setEspecializacao] = useState('')
    const [especializadoOutros_descri, setEspecializadoOutros_descri] = useState('')


    const [telefoneCelularAnterior, setTelefoneCelularAnterior] = useState('')    
    const [complexidadeAnterior, setComplexidadeAnterior] = useState('')
    const [contratoGestaoAnterior, setContratoGestaoAnterior] = useState('')
    const [nomeOutraOrganizacaoGestoraAnterior, setNomeOutraOrganizacaoGestoraAnterior] = useState('')
    const [emailRepresentanteAnterior, setEmailRepresentanteAnterior] = useState('')
    const [siteAnterior, setSiteAnterior] = useState('')
    const [vinculacaoSUSAnterior, setVinculacaoSUSAnterior] = useState('')
    const [hospitalEspecializadoAnterior, setHospitalEspecializadoAnterior] = useState()
    const [especializacaoAnterior, setEspecializacaoAnterior] = useState('')
    const [especializadoOutros_descriAnterior, setEspecializadoOutros_descriAnterior] = useState('')

    const [cpf, setCPF] = useState('')
    const [cpfAnterior, setCPFAnterior] = useState('')
    

    useEffect(() => {

        //console.log(adesao_institucional_id)
        window.$('[href="#tab1"]').tab('show');
        history.push(`/AdesaoInstitucional/${adesao_institucional_id}`)

    }, [adesao_institucional_id])


    function voltar() {

        history.push('/AdesaoInstitucional')

    }


    async function adesaoInstitucionalListaServicoSaude() {

        await api.get('adesaoInstitucionalListaServicoSaude').then((response) => {
            //console.log(response.data)

            setListaServicosSaude(response.data.map((rs) =>
                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>
                    {rs.razao_social}
                </option>
            ))

        }).catch((err) => {
            console.log(err.response)
        })

    }


    function salvar() {


        if (!validaCNPJ(cnpj)) {

            window.toastr.error('<b>CNPJ</b> inv&aacute;lido!')
            return false
                
        }

        
        if (cpf && cpf != '' && !validaCPF(cpf.replaceAll('-', '').replaceAll('.', ''))) {

            window.toastr.error('<b>CPF</b> inv&aacute;lido!')
            return false

        }

        if (possuiCnes == '') {

            window.toastr.error('Por favor, informe se o seu hospital <b>possui cadastro no CNES</b>')
            return false
            
        } else {

            if (possuiCnes == '1') {

                var nao_tem_cnes = '0'

                if (cnes == '') {

                    window.toastr.error('Por favor, informe o <b>CNES</b> do seu hospital.')
                    return false

                }

            } else {

                var nao_tem_cnes = '1'

            }

        }

        if (razao_social == '') {

            window.toastr.error('<b>Razão Social</b> não pode ficar em branco!')
            return false

        }

        
        if (cep == '') {

            //window.toastr.error('<b>CEP</b> não pode ficar em branco!')
            //return false

        } else {


            if (cep.replaceAll('-', '').length != 8) {

                window.toastr.error('<b>CEP</b> inválido!')
                return false

            }


        }

        if (nome_fantasia == '') {

            window.toastr.error('<b>Nome Fantasia</b> não pode ficar em branco!')
            return false

        }


        if (varios_cnes == '') {

            window.toastr.error('Por favor, informe se o seu hospital <b>é uma rede ou sistema de saúde com vários CNES de diversas unidades</b>')
            return false

        }



        if (email == '') {

            window.toastr.error('<b>E-mail para contato</b> não pode ficar em branco!')
            return false

        }

        /*
        if (confirmaEmail == '') {

            window.toastr.error('Favor redigitar para <b>confirmar o e-mail</b>!')
            return false

        }

        if (email != '' && confirmaEmail != '') {

            if (email != confirmaEmail) {

                window.toastr.error('<b>E-mails</b> não conferem!')
                return false

            }
            
        }
        */
       


        if (exportarAPI == null) {


            //window.toastr.error('<b>Exportar para API</b> não pode ficar em branco!')
            //return false

        }


        if (nome_pessoa_preenche == '') {


            window.toastr.error('<b>Nome completo da pessoa que está preenchendo este formulário</b> não pode ficar em branco!')
            return false

        }


        if (cargo_pessoa_preenche == '') {

            window.toastr.error('<b>Cargo da pessoa que está preenchendo este formulário</b> não pode ficar em branco!')
            return false

        }

        if (telefone_pessoa_preenche == '') {

            //window.toastr.error('<b>Telefone comercial da pessoa que está preenchendo este formulário</b> não pode ficar em branco!')
            //return false

        }

        /*
        if (cep == '') {

            window.toastr.error('<b>CEP da sede ou principal unidade da organização</b> não pode ficar em branco!')
            return false

        }
        */


        if (endereco == '') {


            window.toastr.error('<b>Endereço da sede ou principal unidade da organização</b> não pode ficar em branco!')
            return false

        }


        if (numero == '') {

            window.toastr.error('<b>Número</b> não pode ficar em branco!')
            return false

        }


        if (municipio == '') {

            window.toastr.error('<b>Município</b> não pode ficar em branco!')
            return false

        }

        /*
        if (uf_codigo == '') {

            window.toastr.error('<b>UF</b> não pode ficar em branco!')
            return false

        }
        */


        if (categoria_adesao == '') {

            window.toastr.error('<b>Categoria de adesão</b> não pode ficar em branco!')
            return false

        }


        if (organizacao_espec_id == '') {

            window.toastr.error('<b>Tipo de organização</b> não pode ficar em branco!')
            return false

        }

        if (organizacao_id == '') {

            window.toastr.error('<b>Natureza da organização</b> não pode ficar em branco!')
            return false

        }


        if (organizacao_ambito_id == '') {

            window.toastr.error('<b>Âmbito da organização</b> não pode ficar em branco!')
            return false

        }

        if (porte_organizacao == '') {

            window.toastr.error('<b>Porte da organização</b> não pode ficar em branco!')
            return false

        }



        


        
        //console.log(cnes.trim())

        if (publica_no_site == null) { publica_no_site = false }

        var dataPost = {


            adesao_institucional_id_ref: adesao_institucional_id_ref,
            categoria_adesao: categoria_adesao,
            cnes: cnes && cnes != '' ? cnes.trim() : null,
            cnpj: cnpj && cnpj != '' ? cnpj.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '') : null,
            
            nao_tem_cnes: nao_tem_cnes,
            varios_cnes: varios_cnes,
            razao_social: razao_social,
            nome_fantasia: nome_fantasia,
            email: email,
            nome_pessoa_preenche: nome_pessoa_preenche,
            cargo_pessoa_preenche: cargo_pessoa_preenche,
            telefone_pessoa_preenche: telefone_pessoa_preenche != '' ? telefone_pessoa_preenche : null,
            cep: cep && cep != '' ? cep.replaceAll('-', '') : null,
            endereco: endereco != '' ? endereco : null,
            numero: numero != '' ? numero : null,
            bairro: bairro != '' ? bairro : null,
            municipio: municipio != '' ? municipio : null,
            uf_codigo: uf_codigo != '' ? uf_codigo : null,
            organizacao_espec_id: organizacao_espec_id != '' ? organizacao_espec_id : null,
            organizacao_id: organizacao_id != '' ? organizacao_id : null,
            organizacao_ambito_id: organizacao_ambito_id != '' ? organizacao_ambito_id : null,
            porte_organizacao: porte_organizacao != '' ? porte_organizacao : null,
            publica_no_site: publica_no_site != '' ? publica_no_site : false,
            metaRtZ2030: metaRtZ2030 != null ? metaRtZ2030.toString().replaceAll(',', '.') : null,
            metaRtZ2050: metaRtZ2050 != null ? metaRtZ2050.toString().replaceAll(',', '.') : null,
            exportarAPI: exportarAPI,
            cnpjAnterior: cnpjAnterior != '' ? cnpjAnterior : null,
            nomeFantasiaAnterior: nomeFantasiaAnterior != '' ? nomeFantasiaAnterior : null,
            razaoSocialAnterior: razaoSocialAnterior != '' ? razaoSocialAnterior : null,
            organizacaoGestoraAnterior: organizacaoGestoraAnterior != '' ? organizacaoGestoraAnterior : null,
            organizacaoGestora: organizacaoGestora != '' ? organizacaoGestora : null,
            ad_usr: sessionStorage.getItem('us_codigo'),

            cepAnterior: cepAnterior != '' ? cepAnterior : null,
            enderecoAnterior: enderecoAnterior != '' ? enderecoAnterior : null,
            numeroAnterior: numeroAnterior != '' ? numeroAnterior : null,
            bairroAnterior: bairroAnterior != '' ? bairroAnterior : null,
            municipioAnterior: municipioAnterior != '' ? municipioAnterior : null,
            ufAnterior: ufAnterior != '' ? ufAnterior : null,
            emailAnterior: emailAnterior != '' ? emailAnterior : null,
            telefoneAnterior: telefoneAnterior != '' ? telefoneAnterior : null,
            nomePessoaPreencheuAnterior: nomePessoaPreencheuAnterior != '' ? nomePessoaPreencheuAnterior : null,
            cargoPessoaPreencheuAnterior: cargoPessoaPreencheuAnterior != '' ? cargoPessoaPreencheuAnterior : null,
            organizacaoAnterior: organizacaoAnterior != '' ? organizacaoAnterior : null,
            organizacao: organizacao != '' ? organizacao : null,
            categoriaAdesaoAnterior: categoriaAdesaoAnterior != '' ? categoriaAdesaoAnterior : null,
            ambitoOrganizacaoAnterior: ambitoOrganizacaoAnterior != '' ? ambitoOrganizacaoAnterior : null,
            ambitoOrganizacao: ambitoOrganizacao != '' ? ambitoOrganizacao : null,
            especOrganizacaoAnterior: especOrganizacaoAnterior != '' ? especOrganizacaoAnterior : null,
            especOrganizacao: especOrganizacao != '' ? especOrganizacao : null,
            porteOrganizacaoAnterior: porteOrganizacaoAnterior != '' ? porteOrganizacaoAnterior : null,
            cnesAnterior: cnesAnterior && cnesAnterior != '' ? cnesAnterior.trim() : null,

            telefoneCelular: telefoneCelular && telefoneCelular != '' ? telefoneCelular : null,
            telefoneCelularAnterior: telefoneCelularAnterior && telefoneCelularAnterior != '' ? telefoneCelularAnterior : null,
            complexidade: complexidade != '' ? complexidade : null,
            complexidadeAnterior: complexidadeAnterior != '' ? complexidadeAnterior : null,
            contratoGestao: contratoGestao != '' ? contratoGestao : null,
            contratoGestaoAnterior: contratoGestaoAnterior != '' ? contratoGestaoAnterior : null,
            nomeOutraOrganizacaoGestora: nomeOutraOrganizacaoGestora != '' ? nomeOutraOrganizacaoGestora : null,
            nomeOutraOrganizacaoGestoraAnterior: nomeOutraOrganizacaoGestoraAnterior != '' ? nomeOutraOrganizacaoGestoraAnterior : null,
            emailRepresentante: emailRepresentante != '' ? emailRepresentante : null,
            emailRepresentanteAnterior: emailRepresentanteAnterior != '' ? emailRepresentanteAnterior : null,
            site: site != '' ? site : null,
            siteAnterior: siteAnterior != '' ? siteAnterior : null,
            vinculacaoSUS: vinculacaoSUS != '' ? vinculacaoSUS : null,
            vinculacaoSUSAnterior: vinculacaoSUSAnterior != '' ? vinculacaoSUSAnterior : null,
            hospitalEspecializado: hospitalEspecializado != '' ? hospitalEspecializado : null,
            hospitalEspecializadoAnterior: hospitalEspecializadoAnterior != '' ? hospitalEspecializadoAnterior : null,
            especializacao: especializacao != '' ? especializacao : null,
            especializacaoAnterior: especializacaoAnterior != '' ? especializacaoAnterior : null,
            especializadoOutros_descri: especializadoOutros_descri != '' ? especializadoOutros_descri : null,
            especializadoOutros_descriAnterior: especializadoOutros_descriAnterior != '' ? especializadoOutros_descriAnterior : null,

            cpf: cpf ? String(cpf).replaceAll('.', '').replaceAll('-', '') : null,
            cpfAnterior: cpfAnterior ? cpfAnterior.replaceAll('.', '').replaceAll('-', '') : null,

        }

        //console.log(dataPost)
        //return false

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    //console.log(`adesaoInstitucional/${adesao_institucional_id}`)
                    //return false
                    

                    api.put(`adesaoInstitucional/${adesao_institucional_id}`, dataPost).then((result) => {
                        
                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Registro salvo com sucesso!')
                            carregaDados()
                            carregaAlteracoes()

                        } else {

                            window.toastr.error('Ocorreu um erro ao salvar, por favor contacte o administrador do sistema')
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    async function adesaoInstitucionalListaOrganizacao() {

        //console.log(categoria_adesao)

        if (categoria_adesao) {

            await api.get(`adesaoInstitucionalListaOrganizacao/${categoria_adesao}`).then((response) => {
                //console.log(response.data)
                setListaOrganizacao(response.data.map((rs) => 
                    <option value={rs.organizacao_espec_id}>
                        {rs.descricao}
                    </option>
                ))
            }).catch((err) => {
                console.log(err.response)
            })

        }

        

    }


    async function consultaCEP() {

        

        if (cep && cep.replaceAll('-', '').length == 8) {

            await axios.get(`https://viacep.com.br/ws/${cep.replaceAll('-', '')}/json/`).then((response) => {

                //console.log(response.data)
                setEndereco(response.data.logradouro)
                setBairro(response.data.bairro)
                setMunicipio(response.data.localidade)
                setUfCodigo(response.data.uf)
                

            }).catch((err) => {
                console.log(err.response)
            })

        }

        


    }


    async function adesaoInstitucionalListaAmbito() {

        if (categoria_adesao) {

            await api.get(`adesaoInstitucionalListaAmbito/${categoria_adesao}`).then((response) => {
                //console.log(response.data)

                setListaAmbito(response.data.map((rs) =>
                
                    <option value={rs.organizacao_ambito_id} key={rs.organizacao_ambito_id}>
                        {rs.descricao}
                    </option>

                ))

            }).catch((err) => {
                console.log(err.response)
            })

        }

    }


    async function adesaoInstitucionalListaNatureza() {

        await api.get('adesaoInstitucionalListaNatureza').then((response) => {
            //console.log(response.data)
            setListaNatureza(response.data.map((rs) => 

                <option value={rs.organizacao_id} key={rs.organizacao_id}>
                    {rs.descricao}
                </option>
            
            ))
        }).catch((err) => {
            console.log(err.response)
        })

    }

    var [meta2020, setMeta2020] = useState('')
    var [meta2030, setMeta2030] = useState('')
    var [meta2040, setMeta2040] = useState('')
    var [meta2050, setMeta2050] = useState('')
    var [anoBase, setAnoBase] = useState('')

    async function carregaDadosMeta() {

        setMeta2050('')
        setMeta2040('')
        setMeta2030('')
        setMeta2020('')
        setAnoBase('')


        if (adesao_institucional_id) {

            await api.get(`desafioClimaMeta/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data)
                var data = result.data[0]
    
                if (data) {
    
                    setMeta2020(data.meta2020)
                    setMeta2030(data.meta2030)
                    setMeta2040(data.meta2040)
                    setMeta2050(data.meta2050)
                    setAnoBase(data.anoBase)

    
                }
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }


        

    }

    async function carregaDados() {

        if (adesao_institucional_id) {


            await api.get(`adesaoInstitucionalListaUm/${adesao_institucional_id}`).then((result) => {
            //console.log(result.data, '!!')
    
            var data = result.data[0]
            //console.log(data)
    
            setRazaoSocial(data.razao_social)
            setEmail(data.email)
            setEndereco(data.endereco)
            setNumero(data.numero)
            setCnes(data.cnes)
            setNomeFantasia(data.nome_fantasia)
            setCep(data.cep)
            setBairro(data.bairro)
            setMunicipio(data.municipio)
            setUfCodigo(data.uf_codigo)
            setCNPJ(data.cnpj)
            setNomePessoaPreenche(data.nome_pessoa_preenche)
            setCargoPessoaPreenche(data.cargo_pessoa_preenche)
            setTelefonePessoaPreenche(data.telefone_pessoa_preenche)
            setCategoriaAdesao(data.categoria_adesao)
            setOrganizacaoAmbitoId(data.organizacao_ambito_id)
            setOrganizacaoEspecId(data.organizacao_espec_id)
            setOrganizacaoId(data.organizacao_id)
            setPorteOrganizacao(data.porteOrganizacao ? String(data.porteOrganizacao) : data.porte_organizacao)
            setPublicaNoSite(data.publica_no_site)
            setCPF(data.cpf_pessoa_preenche)
            setCPFAnterior(data.cpf_pessoa_preenche)
            setAdesao_institucional_id_ref(data.adesao_institucional_id_ref)

            setArquivoRtZ(data.arquivoRtZ)
            setUploadArquivoRtZDataHora(data.uploadArquivoRtZDataHora)
            setStatusArquivoRtZ(data.statusArquivoRtZ == 'P' ? 'Pendente' : data.statusArquivoRtZ == 'V' ? 'Validado' : data.statusArquivoRtZ == 'N' ? 'Não validado' : '')

            setMetaRtZ2030(data.metaRtZ2030)
            setMetaRtZ2050(data.metaRtZ2050)
            setCartaAdesao(data.cartaAdesao)

            setExportarAPI(data.exportarAPI)
            
            setCnpjAnterior(data.cnpj)
            setNomeFantasiaAnterior(data.nome_fantasia)
            setRazaoSocialAnterior(data.razao_social)
            setOrganizacaoGestoraAnterior(data.razao_social_gestora)


            setCepAnterior(data.cep)
            setEnderecoAnterior(data.endereco)
            setNumeroAnterior(data.numero)
            setBairroAnterior(data.bairro)
            setMunicipioAnterior(data.municipio)
            setUfAnterior(data.uf_codigo)
            setEmailAnterior(data.email)
            setTelefoneAnterior(data.telefone_pessoa_preenche)
            setNomePessoaPreencheuAnterior(data.nome_pessoa_preenche)
            setCargoPessoaPreencheuAnterior(data.cargo_pessoa_preenche)

            setOrganizacaoAnterior(data.organizacao)
            setOrganizacao(data.organizacao)
            setCategoriaAdesaoAnterior(data.categoria_adesao)
            setAmbitoOrganizacaoAnterior(data.ambitoOrganizacao)
            setAmbitoOrganizacao(data.ambitoOrganizacao)

            setEspecOrganizacaoAnterior(data.especOrganizacao)
            setEspecOrganizacao(data.especOrganizacao)
            
            
            setTipoOrganizacaoAnterior(data.tipoOrganizacao)
            setPorteOrganizacaoAnterior(data.porte_organizacao)
            setCnesAnterior(data.cnes)


            var varios_cnes = data.varios_cnes

            if (varios_cnes) { varios_cnes = '1' }
            if (!varios_cnes) { varios_cnes = '0' }

            setVariosCnes(varios_cnes)

            var possuiCnes = ''                
            var nao_tem_cnes = data.nao_tem_cnes

            if (nao_tem_cnes) { possuiCnes = '0'}
            if (!nao_tem_cnes) { possuiCnes = '1'}

            setPossuiCnes(possuiCnes)

            
            // campos novos

            setTelefoneCelular(data.telefoneCelular)
            setComplexidade(data.complexidade)
            setContratoGestao(data.contratoGestao)
            setNomeOutraOrganizacaoGestora(data.nomeOutraOrganizacaoGestora)
            setEmailRepresentante(data.emailRepresentante)
            setSite(data.site)
            setVinculacaoSUS(data.vinculacaoSUS)
            setHospitalEspecializado(data.hospitalEspecializado == true ? '1' : data.hospitalEspecializado == false ? '0' : null)
            setEspecializacao(data.especializacao)
            setEspecializadoOutros_descri(data.especializadoOutros_descri)


            setTelefoneCelularAnterior(data.telefoneCelular)
            setComplexidadeAnterior(data.complexidade)
            setContratoGestaoAnterior(data.contratoGestao)
            setNomeOutraOrganizacaoGestoraAnterior(data.nomeOutraOrganizacaoGestora)
            setEmailRepresentanteAnterior(data.emailRepresentante)
            setSiteAnterior(data.site)
            setVinculacaoSUSAnterior(data.vinculacaoSUS)
            setHospitalEspecializadoAnterior(data.hospitalEspecializado == true ? '1' : data.hospitalEspecializado == false ? '0' : null)
            setEspecializacaoAnterior(data.especializacao)
            setEspecializadoOutros_descriAnterior(data.especializadoOutros_descri)



    
        }).catch((err) => {
            console.log(err.response)
        })

        }

    }

    const totalUnidadesVinculadas = () => {

        api.get(`unidadesVinculadasTotal/${adesao_institucional_id}`).then((result) => {

            setTotalOrgAfiliadas(result.data[0].total)

        }).catch((err) => {

            console.log(err)

        })

    }





    const loginCNPJref = () => {



    }



    const filiais = () => {

        api.get(`unidadesVinculadas/${adesao_institucional_id}`).then((result) => {

            var data = result.data

            setUnidadesVinculadas(data.map((rs) => 

                <tr>

                    <td style={{ cursor: 'pointer'}} onClick={() => setAdesaoInstitucional_id(rs.adesao_institucional_id)}>
                        [<font color='orange'>{rs.cnpj}</font>] {rs.nome_fantasia}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function carregaTotais() {

        await api.get(`adesaoInstitucionalTotais/${adesao_institucional_id}`).then((result) => {

            var data = result.data[0]
            //console.log(data)

            setTotalCompras(data.totalCompras)
            setTotalLogin(data.totalLogin)
            setTotalClima(data.totalClima)
            setTotalEnergia(data.totalEnergia)
            setTotalPerfilAnual(data.totalPerfilAnual)
            setTotalResiduos(data.totalResiduos)
            setTotalOcorrencias(data.totalOcorrencias)
            //setTotalAvisos(data.totalAvisos)


        }).catch((err) => {

            console.log(err.response)

        })

    }

    async function uf() {

        api.get('uf').then((result) => {
            //console.log(result.data)

            setListaUF(result.data.map((rs) => 
            
                <option value={rs.uf_codigo} key={rs.uf_codigo}>{rs.uf_codigo}</option>

            ))

        }).catch((err) => {
            console.log(err.response)
        })

    }





     function compras() {

         api.get(`comprasTabelaGestao/${adesao_institucional_id}`).then((result) => {

            //console.log(result.data, 'compras')
            setResultadoCompras(result.data.map((rs) =>
            
                <tr data-toggle="modal" style={{cursor: 'pointer' }} data-target="#modalCompras" onClick={() => { setAno(rs.anoPerfil); setFormulario_id(rs.compras_id); setOrigem('Compras') }}>
                    <td style={{ fontSize: '11px' }}>
                        <center>
                        {rs.anoPerfil}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoI) }}>
                        <center>
                        {rotulo(rs.secaoI)}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoII)}}>
                        <center>
                        {rotulo(rs.secaoII)}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoIII)}}>
                        <center>
                        {rotulo(rs.secaoIII)}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px',  backgroundColor: cor(rs.secaoIV)}}>
                        <center>
                        {rotulo(rs.secaoIV)}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px', backgroundColor: corEnviado(rs.situacaoEnviado)}}>
                        <center>
                        {rotuloEnviado(rs.situacaoEnviado)}
                        </center>
                    </td>
                    <td style={{ fontSize: '11px' }}>
                        <center>
                        {rs.dataEnvio}
                        </center>
                    </td>

                </tr>
            
            ))

            dataTableRender('tabelaCompras')

        }).catch((err) => {

            console.log(err.response)

        })

        


    }


    async function perfilAnual() {

        if (adesao_institucional_id) {


            await api.get(`/perfisAnuais/${adesao_institucional_id}`).then((result) => {
                //console.log(result.data)
                

                setResultadoPerfilAnual(result.data.map((rs) => 

                    <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target={ categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' } onClick={() => {setAno(rs.ano);setFormulario_id(rs.perfilAnual_id);setOrigem('PerfilAnual')}}>
                        <td><center>{rs.ano}</center></td>
                        { /* <td ><center>{rs.complexidade_descri}</center></td> */ }
                        <td>
                            <center>
                                {rs.tfeGeral != null
                                ? Number(rs.tfeGeral).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    })
                                : ''}
                            </center>
                        </td>
                        <td ><center>{rs.leitosOcupados}</center></td>
                        <td ><center>{rs.areaConstruida}</center></td>
                    </tr>

                ))

                dataTableRender('dataTableExamplePerfil')

            }).catch((err) => {
                console.log(err.response)
            })

        }

    }


    

    async function ocorrencias() {


        await api.get(`ocorrencias/${adesao_institucional_id}`).then((result) => {

            setResultadoOcorrencias(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalOcorrencia" onClick={() => setOcorrencia_id(rs.ocorrencia_id)}>
                    <td><center>{rs.data}</center></td>
                    <td><center>{rs.tipoOcorrencia_descri}</center></td>
                    <td>{rs.titulo}</td>
                    <td><center>{rs.us_nome}</center></td>
                </tr>
            
            ))

        })

        dataTableRender('tabelaOcorrencias')

    }


    /*
    async function avisos() {


        await api.get(`avisos/${adesao_institucional_id}`).then((result) => {

            console.log(result.data)

            setResultadoAvisos(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalAviso" onClick={() => setAviso_id(rs.aviso_id)}>
                    <td><center>{rs.data}</center></td>
                    <td>{rs.titulo}</td>
                    <td><center>{rs.us_nome}</center></td>
                    <td><center>{ rs.lido == true ? rs.usuarioLido + ' em ' + rs.dataHoraLido : ''}</center></td>
                </tr>
            
            ))

        })

        dataTableRender('tabelaAvisos')

    }
    */


    function statusArquivo(situacao) {

        
        switch (situacao) {

            case 'P':
                return 'Pendente'
                break

            case 'V':
                return 'Processado'
                break



        }

    }


    function apagar() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                    api.delete(`adesaoInstitucional/${adesao_institucional_id}`).then((result) => {

                        console.log(result.data)
                        //history.push('/Obrigado')
                        window.toastr.success('Registro apagado com sucesso!')
                        history.push('/AdesaoInstitucional')

            
                    }).catch((err) => {
            
                        console.log(err.response)
            
                    })

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }

    async function desafioClima() {

        if (adesao_institucional_id) {



            api.get(`desafioClimaTabelaGestao/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data, 'quadro')

                setResultadoClima(result.data.map((rs) =>

                    <tr >

                        <td style={{ fontSize: '11px'}}><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: cor(rs.secaoAcoesLideranca)}}><center>{rotulo(rs.secaoAcoesLideranca)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: cor(rs.secaoResiliencia)}}><center>{rotulo(rs.secaoResiliencia)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: cor(rs.secaoDadosEmissoes)}}><center>{rotulo(rs.secaoDadosEmissoes)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', display: 'none', backgroundColor: cor(rs.secaoMeta)}}><center>{rotulo(rs.secaoMeta)}</center></td>
                        <td data-toggle="modal" data-target="#modalProcessaPlanilhaClima" onClick={() => setHospClima_id(rs.hospClima_id)} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: rs.statusProcessamentoArquivo == 'V' ? '#bce3d5' : rs.statusProcessamentoArquivo == 'P' ? '#dce3bc' : rs.statusProcessamentoArquivo == 'N' ? '#e3bcbc' : '#efefef' }}><center>{statusArquivo(rs.statusProcessamentoArquivo)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer', backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setFormulario_id(rs.hospClima_id); setOrigem('Clima'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ fontSize: '11px', cursor: 'pointer'}}><center>{rs.dataEnvio}</center></td>

                    </tr>
                
                ))

                dataTableRender('dataTableExampleClima')


            }).catch((err) => {

                console.log(err.response)

            })


            /*


            await api.get(`/desafioClimaListaAnos/${adesao_institucional_id}`).then((result) => {
                //console.log(result.data)
                
                setResultadoClima(result.data.map((rs) => 

                    <tr  >
                        <td style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#modalDesafioClima" onClick={() => setHospClima_id(rs.hospClima_id)}><center>{rs.ano}</center></td>
                        <td style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#modalDesafioClima" onClick={() => setHospClima_id(rs.hospClima_id)}><center>{rs.data}</center></td>
                        <td style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#modalDesafioClima" onClick={() => setHospClima_id(rs.hospClima_id)}>{rs.nomeArquivo}</td>
                        <td data-toggle="modal" data-target="#modalProcessaPlanilhaClima" onClick={() => setHospClima_id(rs.hospClima_id)} style={{ cursor: 'pointer', backgroundColor: rs.statusProcessamentoArquivo == 'V' ? '#bce3d5' : rs.statusProcessamentoArquivo == 'P' ? '#dce3bc' : rs.statusProcessamentoArquivo == 'N' ? '#e3bcbc' : '#efefef' }}><center>{statusArquivo(rs.statusProcessamentoArquivo)}</center></td>
                        
                    </tr>

                ))

                dataTableRender('dataTableExampleClima')

                

            }).catch((err) => {
                console.log(err.response)
            })

            */

        }

    }


    async function residuosSS() {

        if (adesao_institucional_id) {

                await api.get(`residuosTabelaGestao/${adesao_institucional_id}`).then((result) => {

                    
                    //console.log(result.data)
                    setResultadoResiduos(result.data.map((rs) => 
                    

                        <tr style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#modalResiduos" onClick={() => { setFormulario_id(rs.residuo_id); setOrigem('Resíduos'); setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setResiduo_id(rs.residuo_id)}} >

                            <td style={{ fontSize: '11px'}}><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                            <td style={{ fontSize: '11px', backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                            <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoGestao)}} ><center>{rotulo(rs.secaoGestao)}</center></td>
                            <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoGeracao)}}><center>{rotulo(rs.secaoGeracao)}</center></td>
                            <td style={{ fontSize: '11px', backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                            <td style={{ fontSize: '11px'}}><center>{rs.dataEnvio}</center></td>

                        </tr>
                    
                    ))


                dataTableRender('dataTableExampleResiduosSS')

                

            }).catch((err) => {
                console.log(err.response)
            })

        }

    }


    async function energia() {

        if (adesao_institucional_id) {


            api.get(`energiaTabelaGestao/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data, 'aqui energia')

                setResultadoEnergia(result.data.map((rs) =>

                    <tr data-toggle="modal" style={{cursor: 'pointer' }} data-target="#modalEnergia" onClick={() => {setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio);setOrigem('Energia');setFormulario_id(rs.energia_id)}}>

                        <td style={{ fontSize: '11px'}}><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoEficiencia)}} ><center>{rotulo(rs.secaoEficiencia)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoEnergiaEletrica)}} ><center>{rotulo(rs.secaoEnergiaEletrica)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoCombustiveis)}} ><center>{rotulo(rs.secaoCombustiveis)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoAmbientes)}} ><center>{rotulo(rs.secaoAmbientes)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoIluminacao)}} ><center>{rotulo(rs.secaoIluminacao)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoHVAC)}} ><center>{rotulo(rs.secaoHVAC)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoRefrigeracao)}} ><center>{rotulo(rs.secaoRefrigeracao)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoAquecimento)}} ><center>{rotulo(rs.secaoAquecimento)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoGeradores)}} ><center>{rotulo(rs.secaoGeradores)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: cor(rs.secaoSADT)}} ><center>{rotulo(rs.secaoSADT)}</center></td>
                        <td style={{ fontSize: '11px', backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                        <td style={{ fontSize: '11px'}} ><center>{rs.dataEnvio}</center></td>

                    </tr>

                
                ))

                dataTableRender('dataTableExampleEnergia')


            }).catch((err) => {

                console.log(err.response)

            })

          

        }

    }


    function acaoCartaRtZ(acao) {

        var acaoValidar = ''
        var corAcao = 'orange'

        if (acao == 'V') {

            var acaoValidar = 'validar'
            var corAcao = 'green'

        } 

        if (acao == 'N') {

            var acaoValidar = 'não validar'
            var corAcao = 'red'

        }

        var dataPost = {

            acao: acao,
            adesao_institucional_id: adesao_institucional_id,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: corAcao,
		    title: 'Race To Zero',
		    content: `Confirma ${acaoValidar} a carta?`,
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
                    

                    api.post(`acaoRtZ`, dataPost).then((result) => {
                        
                        console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Salvo com sucesso!')
                            //setStatusArquivoRtZ(acao)
                            setStatusArquivoRtZ(acao == 'P' ? 'Pendente' : acao == 'V' ? 'Validado' : acao == 'N' ? 'Não validado' : '')

                        } else {

                            window.toastr.error('Ocorreu um erro ao salvar, por favor contacte o administrador do sistema')
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    async function logins() {


        await api.get(`logins/${adesao_institucional_id}`).then((result) => {

            //console.log(result.data)

            setResultadoLogins(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalLoginAdesaoInstitucional" onClick={() => setLoginId(rs.login_id)} >
                    <td>
                        {rs.nome} { rs.bloqueado ? <span class="label label-danger m-r-15">Bloqueado</span> : '' }
                    </td>
                    <td>
                        <center>{rs.cpf}</center>
                    </td>
                    <td>
                        <center>{rs.perfil == 'A' ? 'Administrador' : 'Usuário' }</center>
                    </td>
                    <td>
                        <center>
                        {rs.dataCriacao}
                        </center>
                    </td>
                </tr>
            
            ))

            

        }).catch((err) => {

            console.log(err.response)

        })

        dataTableRender('tabelaLogins')

    }



    async function verificaPermissao() {


        if (sessionStorage.getItem('permAdesoes') != 'true') {

            history.push('/')

        }


    }

    const abreModalAlteracao = async (alteraAdesaoInstitucional_id) => {


        setAlteraAdesaoInstitucional_id(alteraAdesaoInstitucional_id)
        window.$('#ModalAlteracao').modal('show')

    }

    const carregaAlteracoes = () => {


        api.get(`adesaoInstitucionalAltera/${adesao_institucional_id}`).then((result) => {

            //console.log(result.data)
            setTotalAlteracoes(result.data.length)
            setResultadoAlteracoes(result.data.map((rs) =>
            

                <tr style={{ cursor: 'pointer'}} onClick={() => abreModalAlteracao(rs.alteraAdesaoInstitucional_id)}>

                    <td>
                        <center>
                        {rs.dataAlteracao}
                        </center>
                    </td>
                    <td>
                        
                        {rs.tipoAlteracao}
                        
                    </td>
                    <td>
                        {rs.us_nome}
                    </td>
                   


                </tr>
            
            
            ))

            


        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        if (adesao_institucional_id) {

            verificaPermissao()
            carregaDadosMeta()
            adesaoInstitucionalListaServicoSaude()
            uf()
            adesaoInstitucionalListaNatureza()
            carregaDados()
            carregaTotais()
            carregaAlteracoes()
            totalUnidadesVinculadas()

        }


    }, [adesao_institucional_id])


    useEffect(() => {

        adesaoInstitucionalListaAmbito()
        adesaoInstitucionalListaOrganizacao()

    }, [categoria_adesao])


    useEffect(() => {

        
        compras()
        residuosSS()
        energia()
        desafioClima()
        

    }, [verificaDesafio])

    async function atualizaCartaAdesao() {


        await api.get(`adesaoInstitucionalListaUm/${adesao_institucional_id}`).then((result) => {

            setCartaAdesao(result.data[0].cartaAdesao)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    return (

        <div>
            
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-users'></i>
                </div>
                <div class='header-title'>
                    <h1>Ades&atilde;o Institucional</h1>
                    <small>Administração</small>
                    
                </div>
            </div>

            <div class="row">

                <div class="col-sm-12">

                    
                        <div className="form-group">
                            
                            <input type="text" className="form-control" placeholder="" value={`${cnpj} - ${nome_fantasia}`} disabled style={{ backgroundColor: '#cde7f7'}} />
                                            
                        </div>

                </div>
                
                <div class="col-sm-12">
                    


                    <ul class="nav nav-tabs">
                            <li class="active"><a href="#tab1" data-toggle="tab">Cadastro</a></li>
                            <li><a href="#tab6" data-toggle="tab" onClick={() => logins()}>Logins ({totalLogin})</a></li>
                            <li><a href="#tab11" data-toggle="tab" onClick={() => filiais()}>Org. Afiliadas ({totalOrgAfiliadas})</a></li>
                            <li><a href="#tab5" data-toggle="tab" onClick={() => perfilAnual()}>Perfil Anual ({totalPerfilAnual})</a></li>
                            <li><a href="#tab2" data-toggle="tab" onClick={() => desafioClima()}>Clima ({totalClima})</a></li>
                            <li><a href="#tab10" data-toggle="tab" onClick={() => desafioClima()}>RtZ</a></li>
                            <li><a href="#tab3" data-toggle="tab" onClick={() => residuosSS()}>Resíduos SS ({totalResiduos})</a></li>
                            <li><a href="#tab4" data-toggle="tab" onClick={() => energia()}>Energia ({totalEnergia})</a></li>
                            <li><a href="#tab7" data-toggle="tab" onClick={() => compras()}>Compras ({totalCompras})</a></li>
                            <li style={{ display: 'none'}}><a href="#tab8" data-toggle="tab" onClick={() => ocorrencias()}>Ocorrências ({totalOcorrencias})</a></li>
                            <li><a href="#tab12" data-toggle="tab" >Alterações ({totalAlteracoes})</a></li>
                            {
                                /*

                                <li><a href="#tab9" data-toggle="tab" onClick={() => avisos()}>Avisos ({totalAvisos})</a></li>

                                */
                            }
                            
                        </ul>
                        
                        <div className="tab-content">
                            <div className="tab-pane fade in active" id="tab1">
                                <div className="panel-body">
                                        

                                    <div className="col-12 mb-3">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <font color="brown">Dados cadastrais da organização</font>
                                        </h4>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>CNPJ</label>
                                            <input type="text" className="form-control" placeholder="" value={cnpj} onChange={event => setCNPJ(event.target.value)}  />
                                                            
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label>Razão Social</label>
                                            <input type="text" className="form-control" placeholder="" value={razao_social} onChange={event => setRazaoSocial(event.target.value)}  />
                                                            
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Nome Fantasia</label>
                                            <input type="text" className="form-control" placeholder="" value={nome_fantasia} onChange={event => setNomeFantasia(event.target.value)}  />
                                            
                                        </div>
                                    </div>

                                            

                                    
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Possui CNES?</label>
                                            <select className="form-control" onChange={event => setPossuiCnes(event.target.value)} value={possuiCnes}>
                                                <option value="">[Selecione]</option>
                                                <option value='1'>Sim</option>
                                                <option value='0'>Não</option>
                                            </select>  
                                            
                                        </div>
                                    </div>
                                    


                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>CNES</label>
                                            <input type="text" className="form-control" placeholder="" value={cnes} onChange={event => setCnes(event.target.value)} />
                                            
                                        </div>
                                    </div>
                                    


                                    <div className="col-md-2">
                                        <div class="form-group">
                                            <label for="exampleInputEmail1">CEP</label>
                                            <input type="email" className="form-control" placeholder="" value={cep} onChange={event => setCep(event.target.value)} />
                                            
                                        </div>
                                    </div>

                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <label>Endereço</label>
                                            <input type="text" className="form-control" placeholder="" value={endereco} onChange={event => setEndereco(event.target.value)} />
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Número/Complemento</label>
                                            <input type="text" className="form-control" placeholder="" value={numero} onChange={event => setNumero(event.target.value)} />
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Bairro</label>
                                            <input type="text" className="form-control" placeholder="" value={bairro} onChange={event => setBairro(event.target.value)} />
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Município</label>
                                            <input type="text" className="form-control" placeholder="" value={municipio} onChange={event => setMunicipio(event.target.value)} />
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>UF</label>
                                            <select className="form-control" value={uf_codigo} onChange={event => setUfCodigo(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {listaUF}
                                            </select>
                                            
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">E-mail institucional</label>
                                            <input type="email" className="form-control" placeholder="" value={email} onChange={event => setEmail(event.target.value)} />
                                            
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Endereço ou website da organização</label>
                                            <input className="form-control" input="text" onChange={event => setSite(event.target.value)} value={site} />
                                                            
                                        </div>
                                    </div>




                                    <div class="col-md-12">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <span style={{ color: "brown" }}>
                                                Dados do representante da organização perante o PHS
                                            </span>
                                        </h4>
                                    </div>


                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">CPF</label>                                            
                                            <InputMask                                            
                                            mask="999.999.999-99"
                                             className="form-control" placeholder="" value={cpf} onChange={event => setCPF(event.target.value)} 
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Telefone comercial</label>
                                            <InputMask mask="(99) 99999-9999" className="form-control" placeholder="" value={telefone_pessoa_preenche} onChange={event => setTelefonePessoaPreenche(event.target.value)} />
                                            
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Telefone celular</label>
                                            <InputMask mask="(99) 99999-9999" className="form-control" placeholder="" value={telefoneCelular} onChange={event => setTelefoneCelular(event.target.value)} />
                                            
                                        </div>
                                    </div>




                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label >Nome</label>
                                            <input type="email" className="form-control" placeholder="" value={nome_pessoa_preenche} onChange={event => setNomePessoaPreenche(event.target.value)} />
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Cargo </label>
                                            <input type="email" className="form-control" placeholder="" value={cargo_pessoa_preenche} onChange={event => setCargoPessoaPreenche(event.target.value)} />
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Email institucional do representante</label>
                                            <input className="form-control" input="text" onChange={event => setEmailRepresentante(event.target.value)} value={emailRepresentante} />
                                                            
                                        </div>
                                    </div>


                                      <div class="col-md-12">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <span style={{ color: "brown" }}>
                                                Caracterização da Instituição
                                            </span>
                                        </h4>
                                    </div>



                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label"><br/>Categoria de adesão: *</label>
                                            <select class="form-control"  onChange={event => setCategoriaAdesao(event.target.value)} value={categoria_adesao}>
                                                <option value="">[Selecione]</option>
                                                <option value="S" >Serviços de assistência à saúde</option>
                                                <option value="G" >Organizações gestoras de redes de assistência à saúde</option>
                                                <option value="A" >Organizações acadêmicas, profissionais ou representativas da sociedade civil em geral</option>
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-12" style={{ display: categoria_adesao == 'S' ? 'table-row' : 'none' }}>
                                        <div class="form-group" >
                                            <label className="control-label" >Sua unidade pertence ou é gerenciada por alguma das redes de serviços de saúde, organizações sociais de saúde ou sistemas de saúde listados abaixo?</label>
                                            <select class="form-control" onChange={event => {setAdesao_institucional_id_ref(event.target.value);setOrganizacaoGestora(event.target.options[event.target.selectedIndex].text)}} value={adesao_institucional_id_ref} >
                                            <option value="">[Selecione]</option>
                                            {listaServicosSaude}
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Tipo da organização</label>
                                            <select className="form-control" value={organizacao_espec_id} onChange={event => {setOrganizacaoEspecId(event.target.value);setEspecOrganizacao(event.target.options[event.target.selectedIndex].text)}}>
                                                <option value="">[Selecione]</option>
                                                {listaOrganizacao}
                                            </select>
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Natureza da Organização</label>
                                            <select class="form-control" value={organizacao_id}  onChange={event => {setOrganizacaoId(event.target.value);setOrganizacao(event.target.options[event.target.selectedIndex].text)}}>
                                                <option value="">[Selecione]</option>
                                                {listaNatureza}
                                            </select>
                                            
                                        </div>
                                    </div>

                                    

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Âmbito da organização</label>
                                            <select className="form-control" value={organizacao_ambito_id} onChange={event => {setOrganizacaoAmbitoId(event.target.value);setAmbitoOrganizacao(event.target.options[event.target.selectedIndex].text)}}>
                                                <option value="">[Selecione]</option>
                                                {listaAmbito}
                                            </select>
                                            
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Sua unidade possui vinculação ao SUS?</label>
                                            <select
                                                className="form-control"
                                                onChange={event => setVinculacaoSUS(event.target.value)} value={vinculacaoSUS} 
                                                >
                                                <option value="">[Selecione]</option>
                                                <option value="Sem atendimento SUS">Sem atendimento SUS</option>
                                                <option value="Abaixo de 60% dos atendimentos SUS">Abaixo de 60% dos atendimentos SUS</option>
                                                <option value="60% ou mais dos atendimentos SUS">60% ou mais dos atendimentos SUS</option>
                                                
                                                </select>
                                                            
                                        </div>
                                    </div>


                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Porte da organização - número de funcionários onários que trabalham na unidade, rede ou organização em questão, incluindo terceirizados e prestadores de serviços com carga horária semanal de 20 ou mais horas): *</label>
                                            <input className="form-control" input="text" onChange={event => setPorteOrganizacao(event.target.value)} value={porte_organizacao} />
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>A sua organização é proprietária da unidade ou opera por contrato de gestão?</label>
                                            <select
                                                className="form-control"
                                                onChange={event => setContratoGestao(event.target.value)} value={contratoGestao} 
                                                >
                                                <option value="">[Selecione]</option>
                                                <option value="Somos proprietários e operadores principais da unidade">Somos proprietários e operadores principais da unidade</option>
                                                <option value="Operamos uma unidade municipal como OSS (Organização Social de Saúde)">Operamos uma unidade municipal como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade estadual como OSS (Organização Social de Saúde)">Operamos uma unidade estadual como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade federal como OSS (Organização Social de Saúde)">Operamos uma unidade federal como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade municipal como PPP (Parceria Público-Privada)">Operamos uma unidade municipal como PPP (Parceria Público-Privada) </option>
                                                <option value="Operamos uma unidade estadual como PPP (Parceria Público-Privada)">Operamos uma unidade estadual como PPP (Parceria Público-Privada) </option>
                                                <option value="Operamos uma unidade federal como PPP (Parceria Público-Privada)">Operamos uma unidade federal como PPP (Parceria Público-Privada)</option>
                                                
                                                </select>
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Complexidade</label>

                                            <Table  bordered hover >
                                                <tbody>
                                                <tr>
                                                    <td colSpan={2}>
                                                    Tipo de unidade de saúde por complexidade dos serviços prestados*:
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ width: '100px' }}>
                                                    <input
                                                        type="radio"
                                                        value="B"
                                                        name='complexidade'
                                                        onChange={event => setComplexidade(event.target.value)}
                                                        checked={ complexidade == 'B' }
                                                    />
                                                    </td>
                                                    <td>
                                                    
                                                    
                                                        Baixa complexidade
                                                        

                                                    
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="M"
                                                        name='complexidade'
                                                        onChange={event => setComplexidade(event.target.value)}
                                                        checked={ complexidade == 'M'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Média complexidade
                                                    
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="A"
                                                        name='complexidade'
                                                        onChange={event => setComplexidade(event.target.value)}
                                                        checked={ complexidade == 'A'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Alta complexidade
                                                    

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="T"
                                                        name='complexidade'
                                                        onChange={event => setComplexidade(event.target.value)}
                                                        checked={ complexidade == 'T'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Alta complexidade com transplante de órgão

                                                    
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                            
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-12">


                                        <Table  bordered hover>
                                            <tbody>
                                                
                                                <tr>
                                                <td  colSpan={2}>
                                                    Sua unidade de saúde é dedicada a uma especialidade?
                                                    

                                                </td>
                                                </tr>

                                                {/* SELECT */}
                                                <tr>
                                                <td colSpan={2}>
                                                    <select
                                                    className="form-control"
                                                    value={hospitalEspecializado}
                                                    onChange={event => setHospitalEspecializado(event.target.value)}
                                                    >
                                                    <option value="">[Selecione]</option>
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                    </select>

                                                </td>
                                                </tr>

                                                {/* PERGUNTA EXTRA */}
                                                <tr style={{ display: hospitalEspecializado === '1' ? 'table-row' : 'none' }}>
                                                <td colSpan={2}>
                                                    Favor assinalar abaixo a opção aplicável:
                                                </td>
                                                </tr>

                                                {/* RADIO OPTIONS */}
                                                {[
                                                { value: 'C', label: 'Cardiologia' },
                                                { value: 'M', label: 'Maternidade/ Obstetrícia/ Ginecologia' },
                                                { value: 'N', label: 'Oncologia' },
                                                { value: 'P', label: 'Pediatria' },
                                                { value: 'S', label: 'Psiquiatria' },
                                                { value: 'O', label: 'Outros' }
                                                ].map((item) => (
                                                <tr
                                                    key={item.value}
                                                    style={{ display: hospitalEspecializado === '1' ? 'table-row' : 'none' }}
                                                >
                                                    <td style={{ width: '100px' }}>
                                                    <input
                                                        type="radio"
                                                        value={item.value}
                                                        checked={ item.value == especializacao }
                                                        onChange={event => setEspecializacao(item.value)}
                                                    />
                                                    </td>
                                                    <td>{item.label}</td>
                                                </tr>
                                                ))}

                                                {/* TEXTAREA OUTROS */}
                                                <tr style={{ display: especializacao === 'O' ? 'table-row' : 'none' }}>
                                                <td colSpan={2}>
                                                    <textarea
                                                    className="form-control"
                                                    rows={5}
                                                    placeholder="Descreva..."
                                                    value={especializadoOutros_descri}
                                                    maxLength={4000}
                                                    onChange={event => setEspecializadoOutros_descri(event.target.value)}
                                                    />

                                                </td>
                                                </tr>

                                            </tbody>
                                            </Table>



                                    </div>



                                    

                                    
                                                
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Publica no site</label>
                                            <select className="form-control" value={publica_no_site} onChange={event => setPublicaNoSite(event.target.value)}>
                                                <option value={false}>Não</option>
                                                <option value={true}>Sim</option>
                                            </select>
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ display: 'none'}}>
                                        <div className="form-group">
                                            <label>Exportar para API</label>
                                            <select className="form-control" value={exportarAPI} onChange={event => setExportarAPI(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value={false}>Não</option>
                                                <option value={true}>Sim</option>
                                            </select>
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Carta de adesão</label>
                                            <input type="text" className="form-control"  value={cartaAdesao} readOnly style={{ cursor: cartaAdesao ? 'pointer' : 'auto' }} onClick={() => cartaAdesao ? window.open(`${linkAPI}uploads/cartaAdesao/${cartaAdesao}`) : ''} />
                                                            
                                        </div>
                                    </div>
                                    
                                  


                                </div>
                            </div>


                                    

                                    {
                                        /*


                                        
                                        setComplexidade(data.complexidade)
                                        
                                        setNomeOutraOrganizacaoGestora(data.nomeOutraOrganizacaoGestora)
                                        
                                        setHospitalEspecializado(data.hospitalEspecializado)
                                        setEspecializacao(data.especializacao)
                                        setEspecializadoOutros_descri(data.especializadoOutros_descri)


                                        */
                                    }

                                 
                            <div className="tab-pane fade" id="tab10">
                                <div className="panel-body">

                                    <div className="col-md-6" >
                                        <div className="form-group">
                                            <label>Upload da carta de adesão em</label>
                                            <input className="form-control" input="text" value={uploadArquivoRtZDataHora} disabled  />
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div className="form-group">
                                            <label>Carta de adesão</label>
                                            <input className="form-control" input="text" value={arquivoRtZ} readOnly style={{cursor: 'pointer'}} onClick={() => window.open(`${linkAPI}uploads/RtZ/${arquivoRtZ}`)}/>
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div className="form-group">
                                            <label>Status</label>
                                            <input className="form-control" input="text" value={statusArquivoRtZ} disabled style={{ backgroundColor: statusArquivoRtZ == 'Pendente' ? '#f5f5dc' : statusArquivoRtZ == 'Validado' ? '#dcf5e1' : statusArquivoRtZ == 'Não validado' ? '#f5dcdc' : '#EFEFEF'}} />
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Meta RtZ 2030</label>
                                            <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$" value={meta2030} onChange={event => setMeta2030(event.target.value)} readOnly />
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Meta RtZ 2050</label>
                                            <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$" value={meta2050} onChange={event => setMeta2050(event.target.value)} readOnly />
                                            
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-12" style={{ display: 'none'}}>
                                        <br/>
                                        <button type="button" class="btn btn-success" onClick={() => acaoCartaRtZ('V')} >Validar carta</button>&nbsp;
                                        <button type="button" class="btn btn-danger" onClick={() => acaoCartaRtZ('N')}  >Não validar carta</button>&nbsp;
                                    </div>


                                </div>
                            </div>
                            <div className="tab-pane fade" id="tab2">
                                <div className="panel-body">
                                    
                                    <div className="table-responsive">
                                        <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th tyle={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Ano
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}> 

                                                        <center>
                                                        Form. Perfil Anual
                                                        </center>

                                                    </th>
                                                
                                                    
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Ações de Liderança
                                                        </center>

                                                    </th>
                                                    
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Resiliência
                                                        </center>

                                                    </th>
                                                    

                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Dados de Emissões de GEE
                                                        </center>

                                                    </th>


                                                    <th style={{ display: 'none', backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Definição da meta
                                                        </center>

                                                    </th>

                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Processamento planilha
                                                        </center>

                                                    </th>
                                                    
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Situação
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Data envio
                                                        </center>

                                                    </th>

                                                    
                                                </tr>
                                                
                                            </thead>
                                            <tbody>
                                                {resultadoClima}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>
                            
                            <div class="tab-pane fade" id="tab7">
                                <div class="panel-body">
                                    
                                    <div className="table-responsive">
                                        <table id="tabelaCompras" className="table table-bordered table-striped table-hover">
                                        <thead>
                                                <tr>
                                                    <th><center>Ano</center></th>
                                                    <th><center>Seção I</center></th>
                                                    <th><center>Seção II</center></th>
                                                    <th><center>Seção III</center></th>
                                                    <th><center>Seção IV</center></th>
                                                    <th><center>Situação</center></th>
                                                    <th><center>Enviado em</center></th>                                                    
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resultadoCompras}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="tab12">
                                <div class="panel-body">

                                    
                                    <div className="table-responsive">
                                        <table id="tabelaAlteracoes" className="table table-bordered table-striped table-hover">
                                        <thead>
                                                <tr>
                                                    <th><center>Em</center></th>
                                                    <th>Alterações</th>
                                                    <th>Por</th>
                                                    
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resultadoAlteracoes}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="tab8">
                                <div class="panel-body">

                                    <button type="button" class="btn btn-info" onClick={() => setOcorrencia_id('novo')} data-toggle="modal" data-target="#modalOcorrencia">+ Adicionar</button>
                                    <br/><br/>
                                    
                                    <div className="table-responsive">
                                        <table id="tabelaOcorrencias" className="table table-bordered table-striped table-hover">
                                        <thead>
                                                <tr>
                                                    <th><center>Data</center></th>
                                                    <th><center>Tipo</center></th>
                                                    <th><center>Título</center></th>
                                                    <th><center>Por</center></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resultadoOcorrencias}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="tab11">
                                <div class="panel-body">

                                    
                                    
                                    <div className="table-responsive">
                                        <table id="tabelaFiliais" className="table table-bordered table-striped table-hover">
                                        <thead>
                                                <tr>
                                                    <th><center>Unidades</center></th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {unidadesVinculadas}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>

                            {

                                /*

                                <div class="tab-pane fade" id="tab9">
                                    <div class="panel-body">

                                        <button type="button" class="btn btn-info" onClick={() => setAviso_id('novo')} data-toggle="modal" data-target="#modalAviso">+ Adicionar</button>
                                        <br/><br/>
                                        
                                        <div className="table-responsive">
                                            <table id="tabelaAvisos" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                    <tr>
                                                        <th><center>Data</center></th>
                                                        <th>Título</th>
                                                        <th><center>Por</center></th>
                                                        <th><center>Lido por</center></th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {resultadoAvisos}
                                                </tbody>
                                                
                                            </table>
                                        
                                        </div>

                                    </div>
                                </div>

                                */
                            }
                            

                            <div class="tab-pane fade" id="tab3">
                                <div class="panel-body">
                                    
                                    <div className="table-responsive">
                                        <table id="dataTableExampleResiduosSS" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th tyle={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Ano
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}> 

                                                        <center>
                                                        Form. Perfil Anual
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Dados de gestão
                                                        </center>

                                                    </th>
                                                    
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Dados de geração de resíduos
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Situação
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Enviado em
                                                        </center>

                                                    </th>
                                                    
                                                    
                                                    
                                                </tr>
                                                
                                            </thead>
                                            <tbody>
                                                {resultadoResiduos}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>
                            <div class="tab-pane fade" id="tab4">
                                <div class="panel-body">
                                    
                                    <div className="table-responsive">
                                        <table id="dataTableExampleEnergia" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr style={{ fontSize: '11px'}}>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Ano
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}> 

                                                        <center>
                                                        Perfil Anual
                                                        </center>

                                                    </th>
                                                
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Gestão da Eficiência Energética
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Energia Elétrica
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Combustíveis
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Ambientes
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Iluminação
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        HVAC
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Refrigeração
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Aquecimento
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Geradores Estacionários
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        SADT
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Situação
                                                        </center>

                                                    </th>
                                                    <th style={{ backgroundColor: '#bab6b6'}}>
                                                        <center>
                                                        Data envio
                                                        </center>

                                                    </th>
                                                    
                                                </tr>
                                                
                                            </thead>
                                            <tbody>
                                                {resultadoEnergia}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>
                            <div class="tab-pane fade" id="tab6">
                                <div class="panel-body">
                                

                                    
                                    <div className="table-responsive">
                                        <table id="tabelaLogins" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th><center>CPF</center></th>
                                                    <th><center>Perfil</center></th>
                                                    <th><center>Desde</center></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resultadoLogins}
                                            </tbody>
                                            
                                        </table>


                                        <div class="col-md-12">

                                            <br/>
                                                            
                                            
                                            <button type="button" class="btn btn-danger" onClick={() => setLoginId('novo')} data-toggle="modal" data-target="#modalLoginAdesaoInstitucional">+ Adicionar</button>

                                        </div>

                                    
                                    </div>

                                </div>

                            </div>

                            <div class="tab-pane fade" id="tab5">
                                <div class="panel-body">
                                

                                    
                                    <div className="table-responsive">
                                        <table id="dataTableExamplePerfil" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th><center>Ano</center></th>
                                                    
                                                    <th ><center>FTE diário</center></th>
                                                    <th ><center>Leitos ocupados</center></th>
                                                    <th ><center>Área Construída</center></th>
                                                    
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resultadoPerfilAnual}
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                            </div>

                            
                        </div>
                    </div>
                                

                        
                </div>

                <div class="col-md-12">

                    <br/>
                              
                    <button type="button" class="btn btn-info" onClick={() => voltar()}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-success" data-toggle="modal" style={{cursor: 'pointer'}} data-target="#modalDesafios">Dashboard</button>&nbsp;
                    <button type="button" class="btn btn-primary" data-toggle="modal" style={{cursor: 'pointer'}} data-target="#ModalCartaAdesao">Carta de adesão</button>&nbsp;
                    <button type="button" class="btn btn-warning" data-toggle="modal" style={{cursor: 'pointer', display: sessionStorage.getItem('permSenhaInst') == 'true' ? 'table-row' : 'none' }} data-target="#modalAlteraSenhaInstitucional">Alterar senha</button>&nbsp;
                    <button type="button" class="btn btn-success" data-toggle="modal" style={{cursor: 'pointer', display: sessionStorage.getItem('permSenhaInst') == 'true' ? 'table-row' : 'none' }} data-target="#ModalEmailSenha">Envia e-mail link senha</button>&nbsp;
                    <button type="button" class="btn btn-danger" onClick={() => apagar()} style={{display: sessionStorage.getItem('us_codigo') == 2 || sessionStorage.getItem('us_codigo') == 14 ? 'table-row' : 'none'}}>Apagar</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                </div>



            </div>

            <ModalLogin login_id={login_id} logins={logins} adesao_institucional_id={adesao_institucional_id} />
            <ModalPerfilAnual adesao_institucional_id={adesao_institucional_id} ano={ano}  formulario_id={formulario_id} />
            <ModalPerfilAnualCorp adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />

            <ModalProcessaPlanilhaClima hospClima_id={hospClima_id} adesao_institucional_id={adesao_institucional_id} />
            <ModalDesafioClima hospClima_id={hospClima_id} formulario_id={formulario_id} origem={origem} ano={ano} adesao_institucional_id={adesao_institucional_id} fnClima={desafioClima} />
            
            <ModalResiduo adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} origem={origem} ano={ano} residuo_id={residuo_id} residuosSS={residuosSS} />
            
            <ModalEnergia adesao_institucional_id={adesao_institucional_id} ano={ano} fnEnergia={energia}/>
            
            <ModalCompras adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} origem={origem} fnCompras={compras}/>

            <ModalOcorrencia ocorrencia_id={ocorrencia_id} adesao_institucional_id={adesao_institucional_id} ocorrencias={ocorrencias} carregaTotais={carregaTotais} />
            {
                /*
                <ModalAviso aviso_id={aviso_id} adesao_institucional_id={adesao_institucional_id} avisos={avisos} carregaTotais={carregaTotais} />
                */
            }   

            <ModalSenhaAdesaoInstitucional adesao_institucional_id={adesao_institucional_id} />
            <ModalEmailSenha adesao_institucional_id={adesao_institucional_id} />
            <ModalCartaAdesao adesao_institucional_id={adesao_institucional_id}  atualizaCartaAdesao={atualizaCartaAdesao} />

            <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} origem={origem} />
            <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} origem={origem} />

            <ModalEmailVer desafioEmail_id={desafioEmail_id}  />

            <ModalDetalheAlteracao alteraAdesaoInstitucional_id={alteraAdesaoInstitucional_id} />

            <ModalDesafios nome_fantasia={nome_fantasia} adesao_institucional_id={adesao_institucional_id} />
            
        
        </div>

    )

}

export default InstitucionalInfo

